var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPreguntas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.331,
    height: 92.331,
    viewBox: "0 0 92.331 92.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_5946",
    x: 0,
    y: 0,
    width: 92.331,
    height: 92.331,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-preguntas",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -12)",
    filter: "url(#Trazado_5946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5946-2",
    "data-name": "Trazado 5946",
    d: "M124.811,94.371a34.166,34.166,0,1,0,34.165,34.166A34.166,34.166,0,0,0,124.811,94.371Zm21.5,35.14a14.966,14.966,0,0,1-1.044,3.459,14.074,14.074,0,0,1-1.87,3.072,15.69,15.69,0,0,1-2.8,2.695q-3.219,2.465-6.394,4.879c-2.117,1.609-4.87,3.331-7.016,4.961a1.591,1.591,0,0,1-.982.314,1.367,1.367,0,0,1-.637-.146,1.777,1.777,0,0,1-.5-.387,1.658,1.658,0,0,1-.335-.544,1.788,1.788,0,0,1-.115-.637v-5.892l-4.686-.1q-1.275,0-2.6-.1a20.755,20.755,0,0,1-2.622-.376,15.973,15.973,0,0,1-2.529-.753,11.28,11.28,0,0,1-2.3-1.212,12.565,12.565,0,0,1-2.779-2.6,14.1,14.1,0,0,1-1.87-3.165,16.477,16.477,0,0,1-1.055-3.553,21.247,21.247,0,0,1-.335-3.781,21.472,21.472,0,0,1,.6-5.057,14.728,14.728,0,0,1,2.038-4.659,11.76,11.76,0,0,1,3.552-3.562,14.045,14.045,0,0,1,4.7-1.829,38.43,38.43,0,0,1,5.234-.721q2.623-.177,5.276-.178t5.276.178a38.43,38.43,0,0,1,5.234.721,14.649,14.649,0,0,1,4.733,1.849,11.438,11.438,0,0,1,3.583,3.542,14.7,14.7,0,0,1,1.975,4.67,22.348,22.348,0,0,1,.271,8.922Z",
    transform: "translate(-78.64 -82.37)",
    fill: "var(--color-primary)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5947",
    "data-name": "Trazado 5947",
    d: "M132.033,117a6.2,6.2,0,0,0-2.167-1,10.793,10.793,0,0,0-2.688-.318,11.864,11.864,0,0,0-2.921.358,9.64,9.64,0,0,0-2.61,1.072v4.676a8.223,8.223,0,0,1,2.47-1.53,6.945,6.945,0,0,1,2.517-.505,2.9,2.9,0,0,1,1.018.171,2.33,2.33,0,0,1,.776.467,1.975,1.975,0,0,1,.49.707,2.309,2.309,0,0,1,.171.893,3.152,3.152,0,0,1-.155,1.018,3.3,3.3,0,0,1-.467.886,6.5,6.5,0,0,1-.754.854q-.443.428-1.033.925a9,9,0,0,0-.978.94,5.237,5.237,0,0,0-.7.995,4.533,4.533,0,0,0-.419,1.11,5.655,5.655,0,0,0-.14,1.305,5.741,5.741,0,0,0,.085.955,4.736,4.736,0,0,0,.241.909h4.086a2.267,2.267,0,0,1-.272-.653,3.039,3.039,0,0,1-.1-.762,3.109,3.109,0,0,1,.14-.971,2.95,2.95,0,0,1,.412-.808,5.283,5.283,0,0,1,.684-.769q.411-.388.955-.839.807-.668,1.429-1.3a7.335,7.335,0,0,0,1.04-1.313,5.764,5.764,0,0,0,.637-1.453,6.3,6.3,0,0,0,.217-1.716,5.774,5.774,0,0,0-.52-2.556A4.717,4.717,0,0,0,132.033,117Z",
    transform: "translate(-93.229 -96.147)",
    fill: "var(--color-primary)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5948",
    "data-name": "Trazado 5948",
    d: "M127.265,135.188a3,3,0,0,0-2.066.73,2.33,2.33,0,0,0-.823,1.818,2.44,2.44,0,0,0,.823,1.833,3.241,3.241,0,0,0,4.117.016,2.4,2.4,0,0,0,.792-1.849,2.319,2.319,0,0,0-.808-1.818A2.918,2.918,0,0,0,127.265,135.188Z",
    transform: "translate(-93.456 -97.772)",
    fill: "var(--color-primary)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPreguntas);
export default __webpack_public_path__ + "static/media/ico-preguntas.4f2392719f7b70b9d4e7d80dcc7a8fa8.svg";
export { ForwardRef as ReactComponent };